import { createFileRoute } from "@tanstack/react-router";
import { AgentEditorPage } from "@/features/agents/agents-page";

export const Route = createFileRoute("/_app/automation/agents/$agentId")({
  head: () => ({ meta: [{ title: "Agent · Malfak" }] }),
  component: AgentRoute,
});

function AgentRoute() {
  const { agentId } = Route.useParams();
  return <AgentEditorPage agentId={agentId} />;
}
